import { render, staticRenderFns } from "./LatestPagesListItemHavsutsikt.vue?vue&type=template&id=35e3b217&scoped=true&"
import script from "./LatestPagesListItemHavsutsikt.vue?vue&type=script&lang=js&"
export * from "./LatestPagesListItemHavsutsikt.vue?vue&type=script&lang=js&"
import style0 from "./LatestPagesListItemHavsutsikt.vue?vue&type=style&index=0&id=35e3b217&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e3b217",
  null
  
)

export default component.exports